var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconWizard = function SvgMiconWizard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M18.254 25.227c.874 0 1.254-.494 1.254-1.178v-.285c0-.684-.38-1.178-1.254-1.178S17 23.08 17 23.764v.285c0 .684.38 1.178 1.254 1.178M14.254 25.227c.874 0 1.254-.494 1.254-1.178v-.285c0-.684-.38-1.178-1.254-1.178S13 23.08 13 23.764v.285c0 .684.38 1.178 1.254 1.178"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 3h26v26H3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentcolor",
    strokeWidth: 2,
    d: "m22 12 3 3-3 3M10 12l-3 3 3 3"
  })));
};
export default SvgMiconWizard;